import React, { useEffect, useState } from "react";

import {
  Text,
  Toast,
  Input,
  Switch,
  EditModal,
  ConfirmAlert,
  GroupInfoBox,
  AddItemButton,
  DeleteAlertComponent,
} from "components";

import { useFlag } from "hooks";
import { changeArrayAt, mq } from "utils";
import { colors, sizes, strings } from "assets/constants";
import { View } from "react-native";
import css from "styles";

export default function Items(props: {
  items: AttributeItemT[];
  onChange: (items: AttributeItemT[]) => void;
}) {
  const { items, onChange } = props;
  const [itemsState, setItemsState] = useState<Array<AttributeItemT>>(items);
  useEffect(() => {
    setItemsState(items);
  }, [items]);

  const [indexToEdit, setIndexToEdit] = useState<number | null>(null);
  const { flg: modal, on: showModal, off: hideModal } = useFlag();
  const { flg: alert, on: showAlert, off: hideAlert } = useFlag();

  const [field, setField] = useState<AttributeItemT>();
  const updateField = (newVal: AttributeItemT) =>
    setField((prev) => ({ ...prev, ...newVal }));

  const _onChangeValue = (value: string) => updateField({ value });
  const _onChangeIsCustomized = (is_customized: 0 | 1) =>
    updateField({ is_customized });

  const resetForm = () => {
    setIndexToEdit(null);
    setField({});
  };

  const _onAdd = () => {
    field && onChange([...items, field]);
    resetForm();
  };

  const _onEdit = () => {
    const tmp =
      typeof indexToEdit === "number" &&
      changeArrayAt(itemsState, indexToEdit, field);
    tmp && onChange(tmp);
  };

  const _onDelete = (close: () => void) => {
    const tmp =
      typeof indexToEdit === "number" && changeArrayAt(itemsState, indexToEdit);
    tmp && onChange(tmp);
    resetForm();
    close();
  };

  const _onConfirm = () => {
    if (!field?.value) {
      Toast.warning({ message: strings.fill_all_fields });
      return;
    }

    const existsAttrs = itemsState?.map((a) => a.value) || [];
    if (existsAttrs.includes(field.value.trim())) {
      Toast.warning({ message: "این مقدار از قبل وجود دارد" });
      return;
    }

    indexToEdit === null ? _onAdd() : _onEdit();
    resetForm();
    hideModal();
  };

  const _onCancel = () => {
    resetForm();
    hideModal();
  };

  return (
    <>
      <View style={css.responsiveListContainer}>
        {itemsState?.length > 0 ? (
          itemsState?.map((value: AttributeItemT, key: number) => {
            return (
              <View key={String(key)} style={css.responsiveBoxContainer}>
                <GroupInfoBox
                  onEdit={() => {
                    setIndexToEdit(key);
                    setField(value);
                    showModal();
                  }}
                  onDelete={() => {
                    setIndexToEdit(key);
                    showAlert();
                  }}
                  title={value.value}
                  icon={{ name: "chevron-left" }}
                />
              </View>
            );
          })
        ) : (
          <Text
            size="sm"
            color={colors.textColorGray}
            style={{ marginBottom: sizes.space / 2 }}
          >
            {strings.no_item_attr}
          </Text>
        )}
      </View>

      <AddItemButton onPress={showModal} />

      <EditModal
        visible={modal}
        onCancel={_onCancel}
        onConfirm={_onConfirm}
        renderForm={() => {
          return (
            <View style={{ paddingBottom: mq(20) }}>
              <Input
                onChangeText={_onChangeValue}
                value={field?.value}
                placeholder={strings.insert_attr_value}
                icon={{ name: "chevron-left" }}
              />

              <Switch
                onChange={_onChangeIsCustomized}
                value={field?.is_customized}
                inactiveLabel="حاوی مقدار غیرعرف مثلا «سایز دلخواه«"
                activeLabel="حاوی مقدار غیرعرف مثلا «سایز دلخواه«"
              />
            </View>
          );
        }}
      />

      <ConfirmAlert
        force
        show={alert}
        hide={hideAlert}
        renderContent={(close) => (
          <DeleteAlertComponent
            description={strings.delete_attribute_item_description}
            removeLoading={false}
            remove={() => _onDelete(close)}
            cancel={close}
          />
        )}
      />
    </>
  );
}
